import axios from 'axios'

const API_PATH = 'api/v2/admins/appointments'

const AppointmentsApiV2 = {
  get  : (q = '', archived = false) => axios.get(API_PATH, { params: { q, archived: String(archived) } }),
  destroy : (id) => axios.delete(`${API_PATH}/${id}`),
  restore : (id) => axios.post(`${API_PATH}/${id}/restore`),
  show : (id) => axios.get(`${API_PATH}/${id}`)
}

export default AppointmentsApiV2
